/**
 * Base64 encoding/decoding for typed arrays.
 *
 * Used by the persistence layer and object library to serialize
 * geometry buffers into JSON-safe strings.
 */

export function uint8ArrayToBase64(arr: Uint8Array): string {
  let binary = "";
  for (let i = 0; i < arr.length; i++) binary += String.fromCharCode(arr[i]);
  return btoa(binary);
}

export function typedArrayToBase64(
  arr: Float32Array | Uint32Array | Uint16Array,
): string {
  const bytes = new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
  let binary = "";
  for (let i = 0; i < bytes.length; i++)
    binary += String.fromCharCode(bytes[i]);
  return btoa(binary);
}

export function base64ToFloat32Array(b64: string): Float32Array {
  const binary = atob(b64);
  if (binary.length % 4 !== 0) {
    throw new Error(
      `Corrupted geometry data: byte length ${binary.length} is not aligned to Float32 (4 bytes).`,
    );
  }
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return new Float32Array(bytes.buffer);
}

export function base64ToUint32Array(b64: string): Uint32Array {
  const binary = atob(b64);
  if (binary.length % 4 !== 0) {
    throw new Error(
      `Corrupted geometry data: byte length ${binary.length} is not aligned to Uint32 (4 bytes).`,
    );
  }
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return new Uint32Array(bytes.buffer);
}

export function base64ToUint8Array(b64: string): Uint8Array {
  const binary = atob(b64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return bytes;
}

export function base64ToUint16Array(b64: string): Uint16Array {
  const binary = atob(b64);
  if (binary.length % 2 !== 0) {
    throw new Error(
      `Corrupted geometry data: byte length ${binary.length} is not aligned to Uint16 (2 bytes).`,
    );
  }
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return new Uint16Array(bytes.buffer);
}
